module.exports = __webpack_public_path__ + "img/п.5.658c43b3.png";